import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import '../assets/scss/main.scss'

import ThemeToggle from './ThemeToggle'

const Layout = ({ children, location }) => {
  let content

  if (location && location.pathname === '/') {
    content = <div>{children}</div>
  } else {
    content = (
      <div id="wrapper" className="page">
        <div>{children}</div>
      </div>
    )
  }

  return (
    <StaticQuery
      query={graphql`
        query SiteMetaQuery {
          site {
            siteMetadata {
              title
              description
              keywords
              author
            }
          }
        }
      `}
      render={data => {
        const meta = data.site.siteMetadata
        return (
          <>
            <Helmet
              htmlAttributes={{
                lang: 'en',
                'data-theme': 'dark',
              }}
              title={meta.title}
              meta={[
                { name: 'description', content: meta.description },
                { name: 'keywords', content: meta.keywords },
                { name: 'author', content: meta.author },
                { property: 'og:title', content: meta.title },
                { property: 'og:description', content: meta.description },
                { property: 'og:type', content: 'website' },
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: meta.title },
                { name: 'twitter:description', content: meta.description },
              ]}
            >
            </Helmet>
            <ThemeToggle />
            {content}
          </>
        )
      }}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
